<template>
  <div class="m-info-window">
    <div class="m-info-window_mask" @click.stop="handleClose"></div>
    <div
      class="m-info-window_box"
      :style="{ '--width': width, '--height': height }"
      @click.stop.prevent="void 0"
    >
      <div class="m-info-window_box-bg"></div>
      <div class="m-info-window_box-header">
        <slot name="header">
          <span>{{ title }}</span>
        </slot>
      </div>
      <div class="m-info-window_box-content">
        <slot></slot>
      </div>
      <div class="m-info-window_box-handle">
        <el-button @click="handleEdit" type="primary" size="mini">{{ $t('修改') }}</el-button>
        <el-button @click="handleClose" type="primary" size="mini">{{ $t('返回') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { isFunction } from '@/utils/is';

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '500px'
    },
    height: {
      type: String,
      default: '300px'
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {};
  },
  methods: {
    handleEdit() {
      this.$emit('edit');
    },
    handleClose(done) {
      this.$destroy();
      isFunction(done) && done();
    }
  },
  mounted() {
    this.container.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.m-info-window {
  width: 100%;
  height: 100%;

  position: absolute;
  left: 0;
  top: 0;
  z-index: 9;

  &_mask {
    position: absolute;
    left: 0;
    top: 0;

    width: 100%;
    height: 100%;

    backdrop-filter: blur(4px);
  }

  &_box {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 9;
    transform: translate(-50%, -50%);

    width: var(--width);
    height: var(--height);

    --margin-top: calc(var(--width) * 0.02);
    --header-height: 40px;
    --handle-height: 26px;

    &-bg {
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;

      width: 100%;
      height: 100%;
      pointer-events: none;

      background: url(/static/image/components/popup-card.png) 0 0 / 100% 100%, no-repeat;
    }

    &-header {
      display: flex;
      justify-content: center;
      align-items: center;

      margin-top: var(--margin-top);
      height: var(--header-height);

      color: #aed6ff;

      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 22px;
    }

    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      height: calc(100% - 110px);
    }

    &-handle {
      height: var(--handle-height);
      margin-top: 10px;

      display: flex;
      justify-content: center;
    }
  }
}
</style>
